import { store } from "../store/index";
import {
  confirmMov,
  filterMovement,
  listMoveToExport,
} from "../store/actions/MovementActions";

/**
 * List stock
 */
export const listFilter = async (filter) => {
  const result = await store.dispatch(filterMovement(filter));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * List export data
 */
export const listToExport = async (filter) => {
  const result = await store.dispatch(listMoveToExport(filter));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Confirm movement
 */
export const confirmMovement = async (batch, newLocation) => {
  const obj = {
    batch: batch,
    toLocationStorageCode: newLocation,
    movementType: "AUTOMATIC",
  };
  const result = await store.dispatch(confirmMov(obj));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};
